import { gql } from '@apollo/client';
import { FR_ISSUES_FIELDS } from './fragments/issue';
import { FR_ASSET_FIELDS } from './fragments/asset';

const issue_status_inner_fields = `
  IssueStatusId
  Name
`;

const asset_inner_fields = `
  __typename
  ... on Machine {
    MachineId
    Name
    SerialNbr 
    MachineType {
      Name
      MachineTypeId
    }
    MachineModel {
      MachineModelId
      Name
    }
    MachineClass {
      Name
    }
    Organization {
       OrganizationId
       Name
    }
    Asset {
      AssetName
      AssetType
    }
    OperationHours {
      MachineMetricId
      Max
      Latest
      Date
      Source
    }
  }
  ... on Equipment {
    EquipmentId
    SerialNbr
    Model
    Name
    EquipmentType {
      EquipmentTypeId
      Name
    }
    EquipmentClass{
      EquipmentClassId
      Name
    }
    Organization {
      OrganizationId
      Name
    }
    Asset {
      AssetName
      AssetType
    }
  }`;

export const issue_fields =
    `
      IssueId
      Description
      Summary
      x
      y
      ObservationDate
      AssetName
      AssetType
      NextScheduledMaintenance
      IssueStatus {` +
    issue_status_inner_fields +
    `}
      Asset {` +
    asset_inner_fields +
    `}
      IssueUser {
        IssueUserId
        IssueUserType {
          IssueUserTypeId 
          Name
        }
        User {
          UserId
          Firstname
          Lastname
        }
        Created
      }
      Access {
        Read
        Create
        Delete
        Update
      }
      EquipmentIssueCount
      Created
      Updated
      Resolved
      ServiceEntry {
        ServiceEntryId
        Name
      }
      Note
      IssueSource {
        IssueSourceId
        Name
      }
      Due
      IssuePriority {
        IssuePriorityId
        Name
      }
      ServiceWork {
        Name
        sv_Name: Name(LangCode: SV)
        en_Name: Name(LangCode: EN)
        no_Name: Name(LangCode: NO)
        Description
        sv_Description: Description(LangCode: SV)
        en_Description: Description(LangCode: EN)
        no_Description: Description(LangCode: NO)
        ServiceTask {
          IsResolvingIssue
          Name
          sv_Name: Name(LangCode: SV)
          en_Name: Name(LangCode: EN)
          no_Name: Name(LangCode: NO)
          Description
          sv_Description: Description(LangCode: SV)
          en_Description: Description(LangCode: EN)
          no_Description: Description(LangCode: NO)
          ServiceTaskId
        }
        ServiceWorkId
      }
      Category {
        CategoryId
        Name
      }
      Assembly {
        AssemblyId
        Name
      }
      Component {
        ComponentId
        Name
      }
`;

const task_fields = `
  TaskId
  TaskStatus {
    TaskStatusId
    Name
  }
  StartDate
  EndDate
  PlannedStartDate
  PlannedEndDate
  Created
  Updated
  TaskType {
    TaskTypeId
    Name
    TaskGroup
    Abbr
    TaskTypeDetails {
        Origin
        Abbr
        Code
        Symbol
    }
  }
`;
const eg_task_fields = `Task {` + task_fields + `}`;

export const GET_ISSUES = gql(`query issues {issues {` + issue_fields + eg_task_fields + `}}`);

export const GET_ISSUEASSETS = gql(`query { issueAssets { ` + asset_inner_fields + `}}`);

export const GET_ISSUE_STATUSES = gql(`query {issueStatuses {` + issue_status_inner_fields + `}}`);

export const CREATE_ISSUE = gql`
    mutation createIssue(
        $Description: String!
        $TaskId: Int
        $Summary: String!
        $Count: Int
        $x: String
        $y: String
        $ResponsiblePersonId: Int
        $MachineId: Int
        $EquipmentId: Int
        $Due: DateTime
        $IssuePriorityId: Int
        $IssuePriority: IssuePriorityEnum
        $ServiceWorkId: Int
        $ObservationDate: DateTime
        $NextScheduledMaintenance: Boolean
        $CategoryId: Int
        $AssemblyId: Int
        $ComponentId: Int
        $IssueType: IssueTypeEnum
        $Private: Boolean
        $Locale: String
        $Impact: IssueImpactEnum
        $Environmental: IssueEnvironmentalEnum
        $ProjectId: Int
        $ItemNumber: String
        $CorrectionProposal: String
        $AddCorrectionAction: [IssueAddCorrectionActionInputType!]
    ) {
        createIssue(
            data: {
                Summary: $Summary
                Description: $Description
                x: $x
                y: $y
                TaskId: $TaskId
                ResponsiblePersonId: $ResponsiblePersonId
                MachineId: $MachineId
                Count: $Count
                EquipmentId: $EquipmentId
                Due: $Due
                IssuePriorityId: $IssuePriorityId
                IssuePriority: $IssuePriority
                ServiceWorkId: $ServiceWorkId
                ObservationDate: $ObservationDate
                NextScheduledMaintenance: $NextScheduledMaintenance
                CategoryId: $CategoryId
                AssemblyId: $AssemblyId
                ComponentId: $ComponentId
                IssueType: $IssueType
                Private: $Private
                Locale: $Locale
                Impact: $Impact
                Environmental: $Environmental
                ProjectId: $ProjectId
                ItemNumber: $ItemNumber
                CorrectionProposal: $CorrectionProposal
                AddCorrectionAction: $AddCorrectionAction
            }
        ) {
            ...fr_IssueFields
        }
    }
    ${FR_ISSUES_FIELDS}
`;
/*export const CREATE_ISSUE = gql(
    `
mutation createIssue(
    $Description: String!, 
    $TaskId: Int, 
    $Summary: String!, 
    $Count: Int, 
    $x: String , 
    $y: String, 
    $ResponsiblePersonId: Int, 
    $MachineId: Int, 
    $EquipmentId: Int, 
    $Due: DateTime, 
    $IssuePriorityId: Int, 
    $ServiceWorkId: Int,
    $ObservationDate: Date,
    $NextScheduledMaintenance: Boolean
    $CategoryId: Int
    $AssemblyId: Int
    $ComponentId: Int
    $IssueType: IssueTypeEnum
    $Private: Boolean
  ) {
  createIssue(data:{
      Summary: $Summary
      Description: $Description
      x: $x
      y: $y
      TaskId: $TaskId
      ResponsiblePersonId: $ResponsiblePersonId
      MachineId: $MachineId
      Count: $Count
      EquipmentId: $EquipmentId
      Due: $Due
      IssuePriorityId: $IssuePriorityId
      ServiceWorkId: $ServiceWorkId,
      ObservationDate: $ObservationDate,
      NextScheduledMaintenance: $NextScheduledMaintenance
      CategoryId: $CategoryId
      AssemblyId: $AssemblyId
      ComponentId: $ComponentId
      IssueType: $IssueType
      Private: $Private
  }) {
      ` +
        issue_fields +
        eg_task_fields +
        `
  }}`
);*/

export const DELETE_ISSUE = gql`
    mutation deleteIssue($IssueId: Int!) {
        deleteIssue(data: { IssueId: $IssueId })
    }
`;

export const UPDATE_ISSUE = gql`
    mutation updateIssue(
        $IssueId: Int!
        $Summary: String
        $Count: Int
        $Description: String
        $x: String
        $y: String
        $TaskId: Int
        $ResponsiblePersonId: Int
        $IssueStatusId: Int
        $IssueStatus: IssueStatusEnum
        $Due: DateTime
        $IssuePriorityId: Int
        $IssuePriority: IssuePriorityEnum
        $ServiceWorkId: Int
        $ObservationDate: DateTime
        $NextScheduledMaintenance: Boolean
        $CategoryId: Int
        $AssemblyId: Int
        $ComponentId: Int
        $IssueType: IssueTypeEnum
        $Private: Boolean
        $Note: String
        $ServiceEntryId: Int
        $ResolverPersonId: Int
        $Resolved: DateTime
        $Locale: String
        $Impact: IssueImpactEnum
        $Environmental: IssueEnvironmentalEnum
        $ItemNumber: String
        $CorrectionProposal: String
        $AddCorrectionAction: [IssueAddCorrectionActionInputType!]
        $UpdateCorrectionAction: [IssueUpdateCorrectionActionInputType!]
        $RemoveCorrectionAction: [IssueRemoveCorrectionActionInputType!]
    ) {
        updateIssue(
            data: {
                IssueId: $IssueId
                Count: $Count
                Summary: $Summary
                Description: $Description
                IssueStatusId: $IssueStatusId
                IssueStatus: $IssueStatus
                x: $x
                y: $y
                TaskId: $TaskId
                ResponsiblePersonId: $ResponsiblePersonId
                Due: $Due
                IssuePriorityId: $IssuePriorityId
                IssuePriority: $IssuePriority
                ServiceWorkId: $ServiceWorkId
                ObservationDate: $ObservationDate
                NextScheduledMaintenance: $NextScheduledMaintenance
                CategoryId: $CategoryId
                AssemblyId: $AssemblyId
                ComponentId: $ComponentId
                IssueType: $IssueType
                Private: $Private
                Note: $Note
                ServiceEntryId: $ServiceEntryId
                ResolverPersonId: $ResolverPersonId
                Resolved: $Resolved
                Locale: $Locale
                Impact: $Impact
                Environmental: $Environmental
                ItemNumber: $ItemNumber
                CorrectionProposal: $CorrectionProposal
                AddCorrectionAction: $AddCorrectionAction
                UpdateCorrectionAction: $UpdateCorrectionAction
                RemoveCorrectionAction: $RemoveCorrectionAction
            }
        ) {
            ...fr_IssueFields
        }
    }
    ${FR_ISSUES_FIELDS}
`;
/*
export const UPDATE_ISSUE = gql(
    `
mutation updateIssue(
    $IssueId: Int!, 
    $Summary: String, 
    $Count: Int, 
    $Description: String, 
    $x: String, 
    $y: String, 
    $TaskId: Int, 
    $ResponsiblePersonId: Int, 
    $IssueStatusId: Int, 
    $Due: DateTime, 
    $IssuePriorityId: Int, 
    $ServiceWorkId: Int, 
    $ObservationDate: Date,
    $NextScheduledMaintenance: Boolean
    $CategoryId: Int
    $AssemblyId: Int
    $ComponentId: Int
    $IssueType: IssueTypeEnum
    $Private: Boolean
  ) {
   updateIssue(data:{
      IssueId: $IssueId
      Count: $Count
      Summary: $Summary
      Description: $Description
      IssueStatusId: $IssueStatusId
      x: $x
      y: $y
      TaskId: $TaskId
      ResponsiblePersonId: $ResponsiblePersonId
      Due: $Due
      IssuePriorityId:$IssuePriorityId
      ServiceWorkId: $ServiceWorkId
      ObservationDate: $ObservationDate,
      NextScheduledMaintenance: $NextScheduledMaintenance
      CategoryId: $CategoryId
      AssemblyId: $AssemblyId
      ComponentId: $ComponentId
      IssueType: $IssueType
      Private: $Private
  }) {
      ` +
        issue_fields +
        eg_task_fields +
        `
  }}`
);
*/
export const UPDATE_ISSUE_STATUS = gql(
    `
  mutation updateIssue($IssueId: Int!, $IssueStatusId: Int!, $ResolverPersonId: Int, $Resolved: DateTime, $Note: String) {
     updateIssue(data:{
        IssueId: $IssueId
        IssueStatusId: $IssueStatusId
        ResolverPersonId: $ResolverPersonId
        Note: $Note
        Resolved: $Resolved
    }) {
        ` +
        issue_fields +
        eg_task_fields +
        `
    }}`
);

export const UPDATE_ISSUE_RESPONSIBLE_PERSON = gql(
    `
mutation updateIssue($IssueId: Int!, $IssueStatusId: Int!, $ResponsiblePersonId: Int) {
   updateIssue(data:{
      IssueId: $IssueId
      IssueStatusId: $IssueStatusId
      ResponsiblePersonId: $ResponsiblePersonId
  }) {
      ` +
        issue_fields +
        eg_task_fields +
        `
  }}`
);

/* ----------------------- fault ---------------------------------------  */

const fault_fields = `
FaultId
Code
Name
Description
fi_name: Name(LangCode: FI)
sv_name: Name(LangCode: SV)
en_name: Name(LangCode: EN)
no_name: Name(LangCode: NO)
fi_description: Description(LangCode: FI)
sv_description: Description(LangCode: SV)
en_description: Description(LangCode: EN)
no_description: Description(LangCode: NO)
FaultType {
  Name
  FaultTypeId
}
Created
Updated`;

export const CREATE_FAULT = gql(`
mutation createFault($Code: String!, $Name: [LangCodeTextInputType!]!, $FaultType: FaultTypeEnum!, $Description: [LangCodeTextInputType!]) {
  createFault(data:{
      Code: $Code
      Name: $Name
      FaultType: $FaultType
      Description: $Description
  }) {
		${fault_fields}
  }}`);

export const DELETE_FAULT = gql`
    mutation deleteFault($FaultId: Int!) {
        deleteFault(data: { FaultId: $FaultId })
    }
`;

export const UPDATE_FAULT = gql(`
mutation updateFault($FaultId: Int!, $Code: String!, $Name: [LangCodeTextInputType!], $FaultType: FaultTypeEnum!, $Description: [LangCodeTextInputType!]) {
  updateFault(data:{
    FaultId: $FaultId
    Code: $Code
    Name: $Name
    FaultType: $FaultType
    Description: $Description
  }) {
		${fault_fields}
  }}`);

export const GET_ISSUE_ROWS = gql`
    query getIssueRows(
        $IssueIds: [Int!]
        $MachineId: Int
        $From: Int
        $To: Int
        $ServiceEntryId: Int
        $IssueStatus: [IssueStatusEnum!]
    ) {
        issueRows(
            data: {
                IssueIds: $IssueIds
                MachineId: $MachineId
                From: $From
                To: $To
                ServiceEntryId: $ServiceEntryId
                IssueStatus: $IssueStatus
            }
        ) {
            TotalRowCount
            Issue {
                ...fr_IssueFields
            }
        }
    }
    ${FR_ISSUES_FIELDS}
`;

export const GET_DEVIATION_ROWS = gql`
    query getDeviationRows(
        $IssueIds: [Int!]
        $MachineId: Int
        $From: Int
        $To: Int
        $ServiceEntryId: Int
        $IssueStatus: [IssueStatusEnum!]
    ) {
        deviationRows(
            data: {
                IssueIds: $IssueIds
                MachineId: $MachineId
                From: $From
                To: $To
                ServiceEntryId: $ServiceEntryId
                IssueStatus: $IssueStatus
            }
        ) {
            TotalRowCount
            Issue {
                ...fr_IssueFields
            }
        }
    }
    ${FR_ISSUES_FIELDS}
`;

export const GET_NEARMISS_ROWS = gql`
    query getNearMissRows(
        $IssueIds: [Int!]
        $MachineId: Int
        $From: Int
        $To: Int
        $ServiceEntryId: Int
        $IssueStatus: [IssueStatusEnum!]
    ) {
        nearmissRows(
            data: {
                IssueIds: $IssueIds
                MachineId: $MachineId
                From: $From
                To: $To
                ServiceEntryId: $ServiceEntryId
                IssueStatus: $IssueStatus
            }
        ) {
            TotalRowCount
            Issue {
                ...fr_IssueFields
            }
        }
    }
    ${FR_ISSUES_FIELDS}
`;

export const GET_OBSERVATION_ROWS = gql`
    query getObservationRows(
        $IssueIds: [Int!]
        $MachineId: Int
        $From: Int
        $To: Int
        $ServiceEntryId: Int
        $IssueStatus: [IssueStatusEnum!]
    ) {
        observationRows(
            data: {
                IssueIds: $IssueIds
                MachineId: $MachineId
                From: $From
                To: $To
                ServiceEntryId: $ServiceEntryId
                IssueStatus: $IssueStatus
            }
        ) {
            TotalRowCount
            Issue {
                ...fr_IssueFields
            }
        }
    }
    ${FR_ISSUES_FIELDS}
`;

export const GET_ACCIDENT_ROWS = gql`
    query getAccidentRows(
        $IssueIds: [Int!]
        $MachineId: Int
        $From: Int
        $To: Int
        $ServiceEntryId: Int
        $IssueStatus: [IssueStatusEnum!]
    ) {
        accidentRows(
            data: {
                IssueIds: $IssueIds
                MachineId: $MachineId
                From: $From
                To: $To
                ServiceEntryId: $ServiceEntryId
                IssueStatus: $IssueStatus
            }
        ) {
            TotalRowCount
            Issue {
                ...fr_IssueFields
            }
        }
    }
    ${FR_ISSUES_FIELDS}
`;

export const GET_ALARM_ROWS = gql`
    query getAlarmRows(
        $IssueIds: [Int!]
        $MachineId: Int
        $From: Int
        $To: Int
        $ServiceEntryId: Int
        $IssueStatus: [IssueStatusEnum!]
    ) {
        alarmRows(
            data: {
                IssueIds: $IssueIds
                MachineId: $MachineId
                From: $From
                To: $To
                ServiceEntryId: $ServiceEntryId
                IssueStatus: $IssueStatus
            }
        ) {
            TotalRowCount
            Issue {
                ...fr_IssueFields
            }
        }
    }
    ${FR_ISSUES_FIELDS}
`;

export const GET_ISSUE = gql`
    query getIssue($IssueId: Int!) {
        issueById(data: { IssueId: $IssueId }) {
            ...fr_IssueFields
        }
    }
    ${FR_ISSUES_FIELDS}
`;

export const GET_ISSUE_ASSET_ROWS = gql`
    query getIssueAssetRows(
        $From: Int
        $To: Int
        $Search: String
        $MachineId: [Int!]
        $EquipmentId: [Int!]
    ) {
        issueAssetRows(
            data: {
                From: $From
                To: $To
                Search: $Search
                MachineId: $MachineId
                EquipmentId: $EquipmentId
            }
        ) {
            TotalRowCount
            IssueAsset {
                ...fr_AssetFields
            }
        }
    }
    ${FR_ASSET_FIELDS}
`;

export const ARCHIVE_ISSUE = gql`
    mutation archiveIssue($IssueId: Int!) {
        archiveIssue(data: { IssueId: $IssueId }) {
            ...fr_IssueFields
        }
    }
    ${FR_ISSUES_FIELDS}
`;

export const GET_DAMAGE_ROWS = gql`
    query getDamageRows(
        $IssueIds: [Int!]
        $MachineId: Int
        $From: Int
        $To: Int
        $ServiceEntryId: Int
        $IssueStatus: [IssueStatusEnum!]
    ) {
        damageRows(
            data: {
                IssueIds: $IssueIds
                MachineId: $MachineId
                From: $From
                To: $To
                ServiceEntryId: $ServiceEntryId
                IssueStatus: $IssueStatus
            }
        ) {
            TotalRowCount
            Issue {
                ...fr_IssueFields
            }
        }
    }
    ${FR_ISSUES_FIELDS}
`;

export const GET_EXPOSURE_ROWS = gql`
    query getExposureRows(
        $IssueIds: [Int!]
        $MachineId: Int
        $From: Int
        $To: Int
        $ServiceEntryId: Int
        $IssueStatus: [IssueStatusEnum!]
    ) {
        exposureRows(
            data: {
                IssueIds: $IssueIds
                MachineId: $MachineId
                From: $From
                To: $To
                ServiceEntryId: $ServiceEntryId
                IssueStatus: $IssueStatus
            }
        ) {
            TotalRowCount
            Issue {
                ...fr_IssueFields
            }
        }
    }
    ${FR_ISSUES_FIELDS}
`;

export const GET_COMPLAINT_ROWS = gql`
    query getComplaintRows(
        $IssueIds: [Int!]
        $MachineId: Int
        $From: Int
        $To: Int
        $ServiceEntryId: Int
        $IssueStatus: [IssueStatusEnum!]
    ) {
        complaintRows(
            data: {
                IssueIds: $IssueIds
                MachineId: $MachineId
                From: $From
                To: $To
                ServiceEntryId: $ServiceEntryId
                IssueStatus: $IssueStatus
            }
        ) {
            TotalRowCount
            Issue {
                ...fr_IssueFields
            }
        }
    }
    ${FR_ISSUES_FIELDS}
`;

export const GET_DATA_BREACH_ROWS = gql`
    query getDataBreachRows(
        $IssueIds: [Int!]
        $MachineId: Int
        $From: Int
        $To: Int
        $ServiceEntryId: Int
        $IssueStatus: [IssueStatusEnum!]
    ) {
        dataBreachRows(
            data: {
                IssueIds: $IssueIds
                MachineId: $MachineId
                From: $From
                To: $To
                ServiceEntryId: $ServiceEntryId
                IssueStatus: $IssueStatus
            }
        ) {
            TotalRowCount
            Issue {
                ...fr_IssueFields
            }
        }
    }
    ${FR_ISSUES_FIELDS}
`;

export const GET_FAILURE_ROWS = gql`
    query getFailureRows(
        $IssueIds: [Int!]
        $MachineId: Int
        $From: Int
        $To: Int
        $ServiceEntryId: Int
        $IssueStatus: [IssueStatusEnum!]
    ) {
        failureRows(
            data: {
                IssueIds: $IssueIds
                MachineId: $MachineId
                From: $From
                To: $To
                ServiceEntryId: $ServiceEntryId
                IssueStatus: $IssueStatus
            }
        ) {
            TotalRowCount
            Issue {
                ...fr_IssueFields
            }
        }
    }
    ${FR_ISSUES_FIELDS}
`;

export const GET_INITIATIVE_ROWS = gql`
    query getInitiativeRows(
        $IssueIds: [Int!]
        $MachineId: Int
        $From: Int
        $To: Int
        $ServiceEntryId: Int
        $IssueStatus: [IssueStatusEnum!]
    ) {
        initiativeRows(
            data: {
                IssueIds: $IssueIds
                MachineId: $MachineId
                From: $From
                To: $To
                ServiceEntryId: $ServiceEntryId
                IssueStatus: $IssueStatus
            }
        ) {
            TotalRowCount
            Issue {
                ...fr_IssueFields
            }
        }
    }
    ${FR_ISSUES_FIELDS}
`;

export const GET_FEEDBACK_ROWS = gql`
    query getFeedbackRows(
        $IssueIds: [Int!]
        $MachineId: Int
        $From: Int
        $To: Int
        $ServiceEntryId: Int
        $IssueStatus: [IssueStatusEnum!]
    ) {
        feedbackRows(
            data: {
                IssueIds: $IssueIds
                MachineId: $MachineId
                From: $From
                To: $To
                ServiceEntryId: $ServiceEntryId
                IssueStatus: $IssueStatus
            }
        ) {
            TotalRowCount
            Issue {
                ...fr_IssueFields
            }
        }
    }
    ${FR_ISSUES_FIELDS}
`;
